// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__j8fWw","image":"NotFound_image__iHRmN","text":"NotFound_text__P-MVF"};